// extracted by mini-css-extract-plugin
export default {"container":"ReceiptPage_container__h0DR5"};